
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage, ElMessageBox } from "element-plus"
import { MatchPool } from "@/store/modules/MatchPoolModule"
import SimulationModal from "./SimulationModal.vue"

export default defineComponent({
  components: {
    SimulationModal
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("池子列表", ["对对碰系统"])
    })

    const store = useStore()
    const tableData = ref<MatchPool[]>([])

    const formData = ref({
      name: '',
      status: '',
      box_type: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    // 模拟弹窗相关
    const simulationDialogVisible = ref(false)
    const currentPool = ref<MatchPool | null>(null)

    const query = () => {
      store
        .dispatch(Actions.GET_MATCH_POOLS, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentMatchPoolsList
          page.value.totalResult = store.getters.currentMatchPoolsCount
        })
        .catch(() => {
          ElMessage.error('获取池子列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        name: '',
        status: '',
        box_type: ''
      }
      page.value.currentPage = 1
      query()
    }

    const onSimulate = (row: MatchPool) => {
      currentPool.value = row
      simulationDialogVisible.value = true
    }

    const onSimulated = () => {
      // 模拟完成后的回调（如果需要）
    }

    const onDelete = (row: MatchPool) => {
      if (row.status === 'active') {
        ElMessage.warning('上线中的池子不能删除，请先下架')
        return
      }

      ElMessageBox.confirm(
        `确定要删除池子「${row.name}」吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          store
            .dispatch(Actions.DELETE_MATCH_POOL, row.id)
            .then((data: { success: boolean; error_msg?: string }) => {
              if (data.success) {
                ElMessage.success('删除成功')
                query()
              } else {
                ElMessage.error(data.error_msg || '删除失败')
              }
            })
            .catch(() => {
              ElMessage.error('删除失败')
            })
        })
        .catch(() => {
          // 取消删除
        })
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      onSimulate,
      onSimulated,
      onDelete,
      simulationDialogVisible,
      currentPool
    }
  },
})
